import { render } from "./MessageAddCartPage.vue?vue&type=template&id=19adf014"
import script from "./MessageAddCartPage.vue?vue&type=script&lang=js"
export * from "./MessageAddCartPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__